import {
  DynamicQuoteProps,
  QuoteBodyProps,
  QuoteTitleProps,
} from 'sly/hubPage/components/HubDynamicContent/DynamicQuote/DynamicQuote.types';

function QuoteBody({ body }: QuoteBodyProps) {
  return (
    <blockquote
      className="font-b-xl mb-l w-[calc(100%-2rem)] text-center font-normal before:content-['“'] after:content-['”'] md:w-[var(--col8)] md:p-xs lg:w-[var(--col10)]"
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
}

function QuoteTitle({ title }: QuoteTitleProps) {
  return (
    <h3
      className='font-b-m mb-xl w-[calc(100%-2rem)] text-center text-slate-lighter-40 md:mb-xxl md:w-[var(--col4)]'
      data-tp-id='gen-h3-f38648af-fe30-49d7-93d3-ed58153ee85c'
    >
      {title}
    </h3>
  );
}

export default function DynamicQuote({
  description,
  title,
}: DynamicQuoteProps) {
  if (!description || !title) {
    return null;
  }
  return (
    <>
      <QuoteBody body={description} />
      <QuoteTitle title={title} />
    </>
  );
}
